import GenericRequest, { METHOD_POST } from '../../../../../shared/webservices/GenericRequest';

export class MachineUpdateTask extends GenericRequest {

    _request; // MachineUpdateRequest

    constructor(request) {
        super(METHOD_POST, request.url());
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/machine/form/update/machine-update/MachineUpdateTask.js